import * as React from 'react';
import { useEffect, useState } from 'react';
import { HeartIcon, ShareIcon } from '@secretescapes/falcon';
import { useTranslations } from '@utils/useTranslations';
import { useFavourite } from '../../hooks/useFavourite';
import { ButtonsWrapper, IconsBox } from './InteractionButtons.styles';

interface InteractionButtonsProps {
  saleId: string;
  saleTitle: string;
  isFavourite?: boolean;
  isMobile: boolean;
}

export const InteractionButtons = ({
  saleId,
  saleTitle,
  isFavourite,
  isMobile,
}: InteractionButtonsProps) => {
  const { translations } = useTranslations();
  const { handleFavouriteChange, buttonText } = useFavourite({ saleId, translations });

  const [localFavouriteState, setLocalFavouriteState] = useState(isFavourite);

  useEffect(() => {
    setLocalFavouriteState(isFavourite);
  }, [isFavourite]);

  const Wrapper = isMobile ? IconsBox : ButtonsWrapper;

  return (
    <Wrapper data-testid="interaction-buttons">
      <HeartIcon
        checked={isFavourite}
        onChange={checked => {
          const previousFavouriteState = localFavouriteState;
          setLocalFavouriteState(checked);
          handleFavouriteChange(checked).catch(() => {
            setLocalFavouriteState(previousFavouriteState);
          });
        }}
        buttonText={isMobile ? '' : buttonText}
      />
      <ShareIcon title={saleTitle} text={saleTitle} />
    </Wrapper>
  );
};
